import React from 'react'
import './Testimonial.css'
//import { Swiper,SwiperSlide } from 'swiper/types'
import {Swiper, SwiperSlide} from 'swiper/react'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/css/pagination';
import 'swiper/css';
import profilePic1 from '../../img/profile1.jpg'
import profilePic2 from '../../img/profile2.jpg'
import profilePic3 from '../../img/profile3.jpg'
import profilePic4 from '../../img/profile4.jpg'


import { themeContext } from '../../Context'
import { useContext } from 'react'


const Testimonial=()=>{
    const theme=useContext(themeContext);
    const darkMode=theme.state.darkMode;

    const clients=[
        {
            img:profilePic1,
            review:"दर्द तब होती है, जब खुद को ठोकर लगती वरना दूसरों के तो सिर्फ लहू ही नजर आते दर्द नहीं "
        },
        {
            img:profilePic2,
            review:" लोग कहते है ज़िंदगी मिली है अपने हिसाब से जीने के लिए, लेकिन वही लोग सुबह होते ही किसी और के हिसाब से जीने चले जाते है  "
        },
        {
            img:profilePic3,
            review:"उसूल और मान्यताएं अलग नहीं होते, तो दुनियां में ना कोई आस्तिक होते ना कोई नास्तिक होते, हर कोई वास्तविक होते। "
        },
        {
            img:profilePic4,
            review:"गलतियों का मकसद बिगाड़ना नहीं सुधारना होता है, ये ज़िंदगी का मायने ज़िंदगी के तजुर्बे सिखलाती है। "
        },
    ]
    return(
    <div className="t-wrapper" id='Testimonial'>
        <div className="t-heading">
            <span>Clients Always get </span>
            <span> Exeptional Work</span>
            <span>From me...</span>
            <div className='blur t-blur1'style={{background:"var(--purple)"}}></div>
            <div className='blur t-blur2'style={{background:"skyblue"}}></div>

        </div>
        {/* slider */}
        <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}  
            slidePerView={1}
        pagination={{ clickable: true }}
        >
        {clients.map((client,index)=>{
            return(
                <SwiperSlide key={index}>
                    <div className='testimonial' >
                    <img src={client.img} alt=""/>
                    <span>{client.review}</span>
                    </div>

                </SwiperSlide>
            );
        })}
        </Swiper> 

    </div>
    )
}
export default Testimonial